import { useState } from "react";
import { Button, Topbar2 } from "../../components";
import ExamFeedback from "./ExamFeedback";
// import SuccessFeedback from "../../components/popup/SuccessFeedback";

const SubmitModule = ({
  candidateDetails,
  applicationDetails,
  scheduleDetails,
}) => {
  const [showFeedbackView, setshowFeedbackView] = useState(false);

  return (
    <div className="w-full h-full bg-gray-200">
      <Topbar2 name={candidateDetails.name} email={candidateDetails.email} />

      {showFeedbackView ? (
        <ExamFeedback applicationDetails={applicationDetails} />
      ) : (
        <div className="w-[95%] h-[85%] mx-auto py-8 flex card my-6 flex-col justify-center items-center relative">
          <h1 className="font-semibold text-2xl capitalize">
            Thank you for taking the assessment !
          </h1>
          <p className="text-lg text-[#919397] mt-2.5 mb-12">
            Expect the feedback soon.
          </p>

          <Button
            text="Give your valuable feedback"
            className={"m-5"}
            version="secondary"
            handleClick={() => {
              setshowFeedbackView(true);
            }}
          />
          <Button
            text="Exit Window"
            handleClick={() => (window.location.href = "/")}
          />
        </div>
      )}
    </div>
  );
};

export default SubmitModule;
